module.exports = __webpack_public_path__ + "img/4-4.e97e3146.svg";